import { Box, type Theme, Typography } from '@mui/material';

const styles = {
  root: {
    height: '100%',
  },
  icon: {
    fontSize: '6.25rem',
    color: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c100,
  },
  title: {
    color: 'secondary',
    marginTop: 2,
    fontSize: '1rem',
  },
  description: {
    color: 'textSecondary',
    marginTop: 1,
    fontSize: '1rem',
  },
};

type EmptyStateProps = {
  Icon: React.ElementType;
  title: string;
  description?: string;
};

export const EmptyState = ({ Icon, title, description = '' }: EmptyStateProps) => {
  return (
    <Box
      sx={styles.root}
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
    >
      <Icon sx={styles.icon} />

      <Typography variant='h5' sx={styles.title}>
        {title}
      </Typography>
      <Typography variant='body1' align='center' sx={styles.description}>
        {description}
      </Typography>
    </Box>
  );
};
